'use client';
import { ReactNode } from 'react';
import LoaderOverlay from 'components/loader-overlay';
import { useCoreContext } from 'providers/core-provider';

interface CoreAddToCartLoaderWrapperProps {
  children: ReactNode;
}

export const CoreAddToCartLoaderWrapper = ({
  children
}: CoreAddToCartLoaderWrapperProps) => {
  const { isAddingToCart } = useCoreContext();
  return (
    <div className=" position-relative">
      {isAddingToCart && <LoaderOverlay />}
      {children}
    </div>
  );
};
